import { render, staticRenderFns } from "./Rename.vue?vue&type=template&id=38a880c4&scoped=true"
import script from "./Rename.vue?vue&type=script&lang=js"
export * from "./Rename.vue?vue&type=script&lang=js"
import style0 from "./Rename.vue?vue&type=style&index=0&id=38a880c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a880c4",
  null
  
)

export default component.exports